export const POST_AGENCY_LINKING_FORM_STARTED =
  "POST_AGENCY_LINKING_FORM_STARTED";
export const POST_AGENCY_LINKING_FORM_SUCCEEDED =
  "POST_AGENCY_LINKING_FORM_SUCCEEDED";
export const POST_AGENCY_LINKING_FORM_FAILED =
  "POST_AGENCY_LINKING_FORM_FAILED";
export const UPDATE_WEBSITE_LOGO_STATE = "UPDATE_WEBSITE_LOGO_STATE";
export const RESET_WEBSITE_LOGO = "RESET_WEBSITE_LOGO";
